<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Ver entrega</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Bodega</a>
        </li>
        <li class="breadcrumb-item active">Entrega</li>
      </ol>
    </div>
    <div v-if="LoadingView===false" class="card">
      <div class="card-header">
        <button class="btn btn-theme" @click="cerrar">Cerrar</button>
      </div>
      <div :class="purchase.deliveryStatus===2?'bg-warning':purchase.deliveryStatus===1?'bg-success':'bg-danger'" class="card-header">
        <h5>Compra: {{ document }}</h5>
      </div>
      <div class="card-body">
        <div class="form-group">
          <div class="row">
            <div class="col-md-3">
              <label class="font-weight-bold">Fecha</label>
              <p>{{ convertDate(purchase.purchase_date) }}</p>
            </div>
            <div class="col-md-3">
              <label class="font-weight-bold">Fecha de entrega</label>
              <p>{{ convertDate(purchase.delivery_date) }}</p>
            </div>
            <div class="col-md-3">
              <label class="font-weight-bold">Localidad</label>
              <p>{{ place.name }}</p>
            </div>
            <div class="col-md-3">
              <label class="font-weight-bold">Proveedor</label>
              <p>{{ provider.nit }} | {{ provider.company }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label class="font-weight-bold">Comprador</label>
              <p>{{ buyer.name }}</p>
            </div>
            <!-- <div class="col-md-3">
                            <label class="font-weight-bold">Cajero</label>
                            <p v-if="sale.state==1">{{chequer.name}}</p>
                            <p v-else>Venta aun no cobrada</p>
                        </div> -->
            <div class="col-md-3">
              <label class="font-weight-bold">Estado</label>
              <br>
              <template>
                <span v-if="purchase.deliveryStatus===2" class="btn btn-warning btn-sm">Pendiente</span>
                <span v-if="purchase.deliveryStatus===1" class="btn btn-success btn-sm">Comprobado</span>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="card-body">
              <table class="table table-responsive">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Producto</th>
                    <th>Ubicacíon</th>
                    <th>Cantidad solicitada</th>
                    <th>Cantidad que llegó</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in purchases" :key="item.id">
                    <td>{{ item.code }}</td>
                    <td>{{ item.nameProduct }}</td>
                    <td>{{ item.location }}</td>
                    <td>{{ myquantity(item.amount) }}</td>
                    <td>
                      <template>
                        <input
                          v-if="purchase.deliveryStatus==2"
                          v-model.number="purchases[getIndex(purchases, item.id)].arrivedAmount"
                          :class="{ 'is-invalid': purchases[getIndex(purchases, item.id)].error===true }"
                          :ref="'arrivedAmount-'+getIndex(purchases,item.id)"
                          type="number"
                          class="form-control"
                          @blur="validateQuantity(getIndex(purchases,item.id))"
                        >
                        <label v-else v-text="purchases[getIndex(purchases, item.id)].arrivedAmount"/>
                      </template>
                    </td>
                    <td v-if="purchase.deliveryStatus==2">
                      <template>
                        <div class="btn-group mr-2"
                             role="group"
                             aria-label="First group">
                          <button v-tooltip.top-center="'Editar ubicación física'" class="btn btn-theme btn-block" @click="openModal2(item)"><i class="icon-fa icon-fa-pencil"/></button>
                          <div class="custom-control custom-checkbox mb-3">
                            <input v-model="purchases[getIndex(purchases, item.id)].status" class="form-check-input" type="checkbox" @change="verify">
                            <label>Listo</label>
                          </div>
                        </div>
                      </template>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="5" class="text-right">
                      <button v-if="checks && purchase.deliveryStatus==2" class="btn btn-success" @click="openModal">Terminar entrega</button>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="LoadingView===true" class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <sweet-modal
      ref="activate_modal"
      icon="info"
      hide-close-button
      blocking
    >
      {{ modalTitleActivate }}
      <button
        slot="button"
        type="button"
        class="btn btn-info"
        @click="$refs.activate_modal.close()"
      >No</button>
      <button
        slot="button"
        type="button"
        class="btn btn-primary ladda-button"
        data-style="expand-right"
        @click="receive()"
      >Si</button>
    </sweet-modal>
    <sweet-modal
      ref="updateLocationModal"
      :title="updatetitle"
      hide-close-button
      blocking
    >
      <div class="card-body">
        <div class="form-group">
          <label>Ubicación</label>
          <input
            :class="{ 'is-invalid': $v.location.$error }"
            v-model.trim="location"
            class="form-control"
            @input="$v.location.$touch()"
          >
          <div v-if="$v.location.$error">
            <span
              v-if="!$v.location.required"
              class="help-block help-block-error"
            >El campo es requerido</span>
          </div>
        </div>
      </div>
      <button
        slot="button"
        type="button"
        class="btn btn-info"
        @click="closeModal"
      >No</button>
      <button
        slot="button"
        type="button"
        class="btn btn-primary ladda-button"
        data-style="expand-right"
        @click="updateLocation()"
      >Si</button>
    </sweet-modal>
  </div>
</template>
<script>
import { xelacode } from '../../../helpers/xelacode'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required } from 'vuelidate/lib/validators'
import ladda from 'ladda'
export default {
  components: {
    SweetModal,
    SweetModalTab
  },
  data () {
    return {
      document: {},
      LoadingView: true,
      place: {},
      seller: {},
      chequer: {},
      sales: [],
      checks: false,
      modalTitleActivate: '',
      purchase: {},
      buyer: {},
      provider: {},
      purchases: [],
      location: '',
      updatetitle: 'Actualizar ubicación fisica del producto',
      idStock: null
    }
  },
  mounted () {
    this.getPurchase()
  },
  validations: {
    location: {
      required
    }
  },
  methods: {
    myquantity (value) {
      return xelacode.quantity(value)
    },
    mymoney (value) {
      return xelacode.money(parseFloat(value))
    },
    getPurchase () {
      let vm = this
      var url = `/api/purchase/showDel/${this.$route.query.id}`
      vm.LoadingView = true
      axios.get(url)
        .then(function (response) {
          vm.purchase = response.data.purchase
          vm.document = response.data.document
          vm.place = response.data.place
          vm.provider = response.data.provider
          vm.buyer = response.data.buyer
          vm.purchases = response.data.purchases
          vm.LoadingView = false
          if (vm.purchase.deliveryStatus == 2 ) {
            vm.equalAmount()
          }

        })
        .catch(function (error) {
          console.log(error)
          vm.LoadingView = false
        })

    },
    getIndex (list, id) {
      return list.findIndex((e) => e.id == id)
    },
    verify () {
      let cont = 0
      this.purchases.forEach(element => {
        if (element.status == true) {
          cont++
        }
      })
      if (cont == this.purchases.length) {
        // alert('si estan chequeados')
        this.checks = true
      } else {
        this.checks = false
      }
    },
    receive () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      let me = this
      l.start()
      axios
        .patch('/api/purchase/receive', {
          id: me.purchase.id,
          purchases: me.purchases
        })
        .then(function (response) {
          // console.log(response)
          l.stop()
          toastr.success(response.data.message, 'Listo')
          me.$refs.activate_modal.close()
          me.getPurchase()
        })
        .catch(function (error) {
          l.stop()
          console.log(error)
          toastr.error(error.response.data.message, 'Error')
        })
    },
    openModal () {
      this.$refs.activate_modal.open()
      this.modalTitleActivate = '¿Está seguro de que los productos llegaron?'
    },
    cerrar () {
      this.$router.push({
        name: 'deliveryIn'
      })
    },
    convertDate (date) {
      var newDate = date.split('-')
      return newDate[2] + '/' + newDate[1] + '/' + newDate[0]
    },
    openModal2 (data) {
      this.$refs.updateLocationModal.open()
      this.idStock = data['idStock']
      this.location = data['location']
    },
    closeModal () {
      this.$v.$reset()
      this.$refs.updateLocationModal.close()
      this.location = ''
      this.idStock = null
      this.getPurchase()
    },
    updateLocation () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios
          .patch('/api/purchase/updateLocation', {
            id: me.idStock,
            location: me.location
          })
          .then(function (response) {
            // console.log(response)
            l.stop()
            toastr.success(response.data.message, 'Listo')
            me.closeModal()
          })
          .catch(function (error) {
            l.stop()
            console.log(error)
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    validateQuantity (item) {
      if (typeof (this.purchases[item].arrivedAmount) !== 'undefined') {
        if (this.purchases[item].arrivedAmount > this.purchases[item].amount) {
          this.purchases[item].arrivedAmount = this.purchases[item].amount
          toastr.error('Existencia insuficiente', 'Error')
          // this.refMultiple('quantity', item);
        } else if (this.purchases[item].arrivedAmount < 0) {
          this.purchases[item].arrivedAmount = 0
          toastr.error('La cantidad no puede ser negativa', 'Error')
          // this.refMultiple('quantity', item)
        }
      }
    },
    equalAmount () {
      this.purchases.forEach(element => {
        element.arrivedAmount = element.amount
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/cellar/deliveryReceived.vue